import React from 'react';
var zhengShuChildren = window.apiObj.zhengShuList.children
var zhengShuArray = []
zhengShuChildren.forEach((element,index) => {
  zhengShuArray.push(
    {
      name: 'block3',
      md: 6,
      xs: 24,
      className: 'content8-block-wrapper',
      children: {
        className: 'content8-block',
        img: {
          className: 'content8-img',
          children:element.image,
        },
        title: {
          className: 'content8-title',
          children: (
            <span>
              <span>
                <span className='overflow-text'>
                  <p>{element.title}</p>
                </span>
              </span>
            </span>
          ),
        },
        content: {
          className: 'content8-content',
          children: (
            <span>
              <p>{element.desc}</p>
            </span>
          ),
        },
      },
    },
  )
});
export const Feature70DataSource = {
  wrapper: {
    className: 'home-page-wrapper feature7-wrapper l5kp8hfix2n-editor_css',
  },
  page: { className: 'home-page feature7 l5kpczhzjkc-editor_css' },
  OverPack: { playScale: 0.3 },
  titleWrapper: {
    className: 'feature7-title-wrapper l5kp8nxln7-editor_css',
    children: [
      {
        name: 'title',
        className: 'feature7-title-h1',
        children: (
          <span>
            <p>关于融云</p>
          </span>
        ),
      },
      {
        name: 'content',
        className: 'feature7-title-content l5kp9fg9w29-editor_css',
        children: (
          <span>
            <p>About Us</p>
          </span>
        ),
      },
    ],
  },
  blockWrapper: {
    className: 'feature7-block-wrapper l5kp82t8nb-editor_css',
    gutter: 24,
    children: [
      {
        md: 6,
        xs: 24,
        name: 'block0',
        className: 'feature7-block',
        children: {
          className: 'feature7-block-group',
          children: [
            {
              name: 'image',
              className: 'feature7-block-image',
              children:
                'https://gw.alipayobjects.com/zos/basement_prod/e339fc34-b022-4cde-9607-675ca9e05231.svg',
            },
            {
              name: 'title',
              className: 'feature7-block-title',
              children: '身份证',
            },
            {
              name: 'content',
              className: 'feature7-block-content',
              children: '识别身份证正反面姓名、身份证号、发证机关等相关信息',
            },
          ],
        },
      },
    ],
  },
};
export const Teams40DataSource = {
  wrapper: {
    className: 'home-page-wrapper content8-wrapper 112l5m8v4q6m2t-editor_css',
  },
  page: { className: 'home-page content8 l5kuaj7rpr-editor_css' },
  OverPack: { playScale: 0.3 },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      // {
      //   name: 'title',
      //   children: (
      //     <span>
      //       <span>
      //         <p>专利证书</p>
      //       </span>
      //     </span>
      //   ),
      //   className: 'title-h1',
      // },
      // {
      //   name: 'content~l5rsufijvdl',
      //   className: '',
      //   children: (
      //     <span>
      //       <p>专业源于专注 服务成就品牌</p>
      //     </span>
      //   ),
      // },
    ],
  },
  block: {
    className: 'content-wrapper',
    children: zhengShuArray
    
  },
};
